import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Company } from '../../models/company.model';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/_service/appconfigservice';

@Injectable({
  providedIn: 'root',
})
export class CompanysService {
  gnBaseURL: any;
  constructor(private http: HttpClient, private appURL: AppConfigService) {
    this.gnBaseURL = this.appURL.getServerUrl();
  }

  getAllCompanys(): Observable<Company[]> {
    return this.http.get<Company[]>(this.gnBaseURL + 'Company/GetCompanyList');
  }

  addCompany(addCompanyRequest: Company): Observable<Company> {
    
    return this.http.post<Company>(
      this.gnBaseURL + 'Company/AddCompany',
      addCompanyRequest
    );
  }

  getCompany(id: string): Observable<Company> {
    return this.http.get<Company>(
      this.gnBaseURL + 'Company/GetCompanyById/' + id
    );
  }

  updateCompany(
    id: number,
    updateCompanyRequest: Company
  ): Observable<Company> {
    return this.http.post<Company>(
      this.gnBaseURL + 'Company/EditCompany/' + id,
      updateCompanyRequest
    );
  }

  deleteCompany(Id: number) {
    return this.http.get(
      this.gnBaseURL + 'Company/'+ Id +'/action/delete' 
    );
  }
}
